export default __webpack_public_path__ + "static/media/backgroundGridReversed.14baa474.svg";